module.exports = __webpack_public_path__ + "img/16.43e2316.webp";